import { DateTime } from "luxon";

enum InfoPopupType {
  info = 'info',
  warning = 'warning',
  error = 'error',
}
interface InfoPopupBase {
  title: string;
  description?: string;
  type: InfoPopupType;
}

interface InfoPopupData extends InfoPopupBase {
  date: DateTime;
}

export {
  InfoPopupType,
  InfoPopupBase,
  InfoPopupData
}
